import React from 'react';
import { ROUTES, SITE_NAME } from '../Constants';

const Footer = () => {
    return (
        <footer className="bg-black text-white py-12 px-6">
            <div className="max-w-7xl mx-auto grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                <div>
                    <h3 className="text-xl font-bold mb-4">{SITE_NAME}</h3>
                    <p>Charitable Society (Reg. No. 723 of 2014)</p>
                    <p className="text-gray-400">
                        G1, Godavari Towers, Vishnupuri Colony, Malkajgiri, Rangareddy, Telangana.
                    </p>
                </div>
                <div>
                    <h3 className="text-xl font-bold mb-4">Quick Links</h3>
                    <ul className="space-y-2">
                        <li><a href={ROUTES.HOME} className="text-gray-400 hover:text-white">Home</a></li>
                        <li><a href={ROUTES.EVENTS} className="text-gray-400 hover:text-white">Events</a></li>
                        <li><a href={ROUTES.GALLERY} className="text-gray-400 hover:text-white">Gallery</a></li>
                        <li><a href={ROUTES.BOARD} className="text-gray-400 hover:text-white">Board Members</a></li>
                        <li><a href={ROUTES.PRIVACYPOLICY} className="text-gray-400 hover:text-white">Privacy Policy</a></li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-xl font-bold mb-4">Contact Us</h3>
                    <ul className="space-y-2">
                        <li className="text-gray-400">Email: rdps.hyd@gmail.com</li>
                        <li className="text-gray-400">Phone: 8897500229, 6304 147 525</li>
                    </ul>
                </div>
            </div>
            <div className="mt-12 border-t border-gray-700 pt-6 text-center text-gray-500">
                &copy; 2024-2025 {SITE_NAME}. All rights reserved.
            </div>
            <div className="border-gray-700 pt-2 text-center text-gray-500">
                Maintained by <a href='http://rennovationsoftware.com'>Rennovation Software</a>
            </div>
        </footer>
    );
};

export default Footer;